<template src="./template.html"></template>
<style src="./styles.scss" lang="scss"></style>

<script>
  import { mapActions, mapState } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import { clone, find, isEqual } from 'lodash'
  import { insertEmoji } from '@/helper'
  import VEmojiPicker from 'v-emoji-picker'
  import FileUploader from '@/components/ui/FileUploader'
  import LinkPreview from '@/components/ui/LinkPreview'
  import SingleSelectInput from '@/components/ui/SingleSelectInput'

  export default {
    name: 'CreatePost',
    components: {
      FileUploader,
      LinkPreview,
      SingleSelectInput,
      MentionInput: () => import('@/components/ui/MentionInput'),
      VEmojiPicker,
    },
    props: {
      group: Number,
      topic: Number,
    },
    data() {
      return {
        emojiOpen: false,
        fileUploaderConfig: {
          // Should add file config properties here which different from FileUploader's baseConfig settings
        },
        link: '',
        postOptions: {},
        selectedTab: null,
      }
    },
    computed: {
      ...mapState('posts', [
        'authors',
        'pending',
        'pendingPreview',
        'post',
        'selectOptions',
      ]),
      ...mapState('auth', [
        'allow_posts_without_grp_and_topic',
        'settings',
      ]),
      ...mapState('auth', { activeUser: 'user' }),
      ...mapFields('posts', [
        'post.description',
        'post.options',
        'post.files',
        'post.author',
      ]),
    },
    watch: {
      'postOptions.types': {
        handler(val, oldVal) {
          if (!isEqual(val, oldVal)) {
            if (val && val.key && !this.topic) {
              this.$delete(this.postOptions, 'topics')
              this.getTopicOptions(val.key)
            } else {
              this.removeTopics()
            }
          }
        },
        deep: true,
      },
      group: {
        handler() {
          this.setGroup()
        },
        immediate: true,
      },
      topic: {
        handler() {
          this.setTopic()
        },
        immediate: true,
      },
    },
    created() {
      if (!this.group) {
        this.getOptions().then(_ => {
          this.getAuthors()
        })
      } else {
        this.getAuthors()
      }
    },
    methods: {
      ...mapActions('posts', [
        'createPost',
        'getAuthors',
        'getLinkPreview',
        'getOptions',
        'getTopicOptions',
        'removeMedia',
        'removePreview',
        'removeTopics',
        'updatePostOptions',
      ]),
      selectEmoji(emoji) {
        insertEmoji(emoji, this, '$refs.message.innerValue')
      },
      setGroup() {
        this.onResultUpdate('types', { 'key': this.group, 'value': '' })
      },
      setTopic() {
        this.onResultUpdate('topics', { 'key': this.topic, 'value': '' })
      },
      toggleTab(type) {
        this.selectedTab = this.selectedTab === type ? null : type
      },
      getPreview(link) {
        this.getLinkPreview(link)
      },
      updateLink(value) {
        this.link = value
      },
      onSubmit() {
        this.createPost().then(status => {
          this.$nextTick(() => {
            this.$refs.postForm.reset()
            this.postOptions = {}
            if (this.group) {
              this.setGroup()
            }
            if (this.topic) {
              this.setTopic()
            }
            this.link = ''
            this.$refs.FileUploader.removeAllFiles()
            this.selectedTab = null
          })
        })
      },
      onResultUpdate(id, args) {
        this.$set(this.postOptions, id, args)
        this.updatePostOptions(clone(this.postOptions))
      },
      onUpdateAuthor(args) {
        this.author = args
      },
      filesChanged(files) {
        this.files = files
      },
      isDisabled(pending, valid, invalid) {
        if (this.allow_posts_without_grp_and_topic) {
          return invalid
        } else {
          return pending || !valid || invalid
        }
      },
      getDefaultOption(type) {
        const optionSet = this.selectOptions.find(x => x.identifier === type)
        if (optionSet && !this.group) {
          return optionSet.properties.find(option => option.value === this.settings.stream_options.default_post_options[type]) || null
        } else {
          return null
        }
      },
      canPostAsAuthor(user) {
        return Boolean(
          user &&
          find(
            user.permissions,
            p => [
              'superadmin',
              'post_as_author',
            ].indexOf(p) !== -1,
          ),
        )
      },
    },
  }
</script>
